import { render, staticRenderFns } from "./ClientCentricityConfigEdit.vue?vue&type=template&id=65c357c0&scoped=true"
import script from "./ClientCentricityConfigEdit.vue?vue&type=script&lang=js"
export * from "./ClientCentricityConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientCentricityConfigEdit.vue?vue&type=style&index=0&id=65c357c0&prod&lang=scss"
import style1 from "./ClientCentricityConfigEdit.vue?vue&type=style&index=1&id=65c357c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c357c0",
  null
  
)

export default component.exports